import fetch from './fetch'

export default {
  getAnnualDataPersonRecords (payload) {
    const request = fetch({
      url: '/annualdata',
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  confirmAnnualData (payload) {
    const request = fetch({
        url: '/annualdata/confirm',
        method: 'post',
        data: {},
        payload
    })

    return request.call()
  },

  getIsAnnualDataConfirmed (payload) {
    const request = fetch({
      url: '/annualdata/confirm',
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/annualData.js